import { render } from "./IntroObjective.vue?vue&type=template&id=192db710"
import script from "./IntroObjective.vue?vue&type=script&lang=js"
export * from "./IntroObjective.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__